import type { InstanceConfig } from '../instance-config';

/**
 * Procurement variant configuration (MoH / Implementing Agency).
 * This extracts all existing hardcoded procurement behavior into config.
 */
export const procurementConfig: InstanceConfig = {
  variant: 'procurement',

  // Overridden at runtime by InstanceConfigProvider from NEXT_PUBLIC_CLIENT_NAME.
  clientName: 'nolia',

  kbCategories: [
    {
      id: 'global',
      labelKey: 'kb.tabGlobal',
      url: '/bases/global',
      wizardConfigId: 'global',
    },
    {
      id: 'project',
      labelKey: 'kb.tabProject',
      url: '/bases/project',
      wizardConfigId: 'project',
    },
    {
      id: 'procurement',
      labelKey: 'kb.tabProcurementActivity',
      url: '/bases/procurement',
      wizardConfigId: 'procurement',
    },
  ],

  navigation: {
    adminItems: [
      { labelKey: 'nav.dashboard',         href: '/',                    iconName: 'HomeSmile' },
      { labelKey: 'nav.knowledgeBases',    href: '/bases/global',        iconName: 'BookOpen02' },
      { labelKey: 'nav.createDocuments',   href: '/validate-documents',  iconName: 'ZapFast', disabled: true },
      { labelKey: 'nav.procure',           href: '/procure',             iconName: 'Grid02', disabled: true },
      { labelKey: 'nav.validateDocuments', href: '/validate-documents',  iconName: 'CheckDone01' },
      { labelKey: 'nav.analytics',         href: '/analytics',           iconName: 'LineChartUp01', disabled: true },
    ],
    operatorItems: [
      { labelKey: 'nav.dashboard',         href: '/',                    iconName: 'HomeSmile' },
      { labelKey: 'nav.validateDocuments', href: '/validate-documents',  iconName: 'CheckDone01' },
    ],
    footerItems: [
      { labelKey: 'nav.team', href: '/user-management', iconName: 'Users01' },
    ],
  },

  features: {
    documentValidation: true,
    languageSelection: true,
    projectKB: true,
    applicationSetup: false,
  },

  activityKBCategory: 'procurement',
  terminologyPrefix: 'procurement',
  assessmentBasePath: '/validate-documents',
};
